<template>
	<div
		id="page-wrapper"
		ref="wrapper"
		:class="{ 'animate-in': showIn }"
		:style="{ '--heightAnimationSpeed': heightAnimationSpeed + 's' }"
		class="container container__large margin-auto pagie-inner-container"
	>
		<div class="side_text left">
			<span class="inner">{{ sideText }}</span>
		</div>
		<slot></slot>
		<div class="side_text right">
			<span class="inner">{{ sideText }}</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'content-wrapper',
	props: ['text'],
	data() {
		return {
			showIn: false,
			heightAnimationSpeed: 0.6,
		}
	},
	mounted() {
		if (this.$refs['wrapper']) {
			const wrapperHeight = this.$refs['wrapper'].getBoundingClientRect().height
			//100px = 0.3s
			if (wrapperHeight) {
				let updatedSpeed = Math.abs(wrapperHeight / 100) * 0.3

				this.heightAnimationSpeed = updatedSpeed > 3 ? 3 : updatedSpeed
			}
		}
		setTimeout(() => {
			this.showIn = true
		}, 300)
	},
	computed: {
		...mapGetters(['currentPage', 'currentPostType', 'isArchive', 'getOptions', 'isFrontPage']),
		sideText() {
			let text = ''
			if (this.text) return this.text
			if (this.currentPage && this.currentPage.title) {
				text = this.currentPage.title
			}
			// if(this.isFrontPage){
			//     text = 'FROTN'
			// }

			return text
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.pagie-inner-container {
	min-height: 200px;
	padding-left: 116px;
	padding-right: 116px;
	position: relative;
	@include mquery($tablet) {
		padding-left: 87px;
		padding-right: 87px;
	}
	@include mquery($phone) {
		padding-left: 0px;
		padding-right: 15px;
	}
	&:after,
	&:before {
		content: '';
		height: 100%;
		width: 2px;
		background-color: var(--dark);
		position: absolute;
		top: 0;
		bottom: 0;
		transition: transform var(--heightAnimationSpeed) ease-in-out;
		backface-visibility: hidden;
		transform: scaleY(0);
		will-change: transform;
		transform-origin: center top;
	}
	&:after {
		right: 0;
		//transform-origin: center bottom;
	}
	&:before {
		left: 0;
		//transform-origin: center top;
		@include mquery($phone) {
			display: none;
		}
	}
	&.animate-in {
		&:after,
		&:before {
			transform: scaleY(1);
		}
	}
	.side_text {
		position: absolute;
		@include fluid-type($smallResText, $wideResText, 11px, 15px);
		&.left {
			left: 0;
			top: 0;
			.inner {
				transform-origin: left top;
				transform: rotate(90deg) translateY(calc(-100% - 2px));
			}
			@include mquery($phone) {
				display: none;
			}
		}
		&.right {
			right: 0;
			bottom: 0;
			@include mquery($phone) {
				right: -17px;
			}
			.inner {
				transform-origin: right bottom;
				transform: rotate(-90deg) translate(100%, -2px);
			}
		}
		.inner {
			display: block;
		}
	}
}
</style>
